import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { first } from "rxjs/operators";

import { ApiService } from "@bitwarden/common/abstractions/api.service";
import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { PlatformUtilsService } from "@bitwarden/common/abstractions/platformUtils.service";
import { StateService } from "@bitwarden/common/abstractions/state.service";
import { VerifyEmailRequest } from "@bitwarden/common/models/request/verify-email.request";
import { ReferralApi } from "../../services/DataService/referral/referral.api";

@Component({
  selector: "app-verify-email-token",
  templateUrl: "verify-email-token.component.html",
})
// eslint-disable-next-line rxjs-angular/prefer-takeuntil
export class VerifyEmailTokenComponent implements OnInit {
  constructor(
    private router: Router,
    private platformUtilsService: PlatformUtilsService,
    private i18nService: I18nService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private logService: LogService,
    private stateService: StateService,
    private referralApi: ReferralApi,
  ) {}

  ngOnInit() {
    // eslint-disable-next-line rxjs-angular/prefer-takeuntil, rxjs/no-async-subscribe
    this.route.queryParams.pipe(first()).subscribe(async (qParams) => {
      if (qParams.userId != null && qParams.token != null) {
        try {
          const response = await this.apiService.postAccountVerifyEmailToken(
            new VerifyEmailRequest(qParams.userId, qParams.token),
          );
          if (await this.stateService.getIsAuthenticated()) {
            // The email is already verified: a failed refresh (e.g. offline) must not turn this
            // into a "verification failed" toast or drop the referral. The next sync or refresh
            // picks up the verified claim (#6269).
            try {
              await this.apiService.refreshIdentityToken();
            } catch (e) {
              this.logService.error(e);
            }
          }
          this.platformUtilsService.showToast("success", null, this.i18nService.t("emailVerified"));

          const targetEmail = response?.email;
          if (qParams.referralCode && targetEmail) {
            this.referralApi.storePendingReferralCode(qParams.referralCode, targetEmail);
          } else if (qParams.referralCode) {
            // #3629: empty-body 200 from verify-email — no verified email to bind the
            // pending referral to, so it can't be stored here. Nothing downstream can
            // recover it from the code alone either; this just surfaces the drop.
            this.logService.warning("verify-email: referral dropped, verify response had no email");
          }
          // Router strips undefined params.
          await this.router.navigate(["/"], {
            queryParams: { email: targetEmail, referralCode: qParams.referralCode },
          });
          return;
        } catch (e) {
          this.logService.error(e);
        }
      }
      this.platformUtilsService.showToast("error", null, this.i18nService.t("emailVerifiedFailed"));
      this.router.navigate(["/"]);
    });
  }
}
